import styled from 'styled-components'

const Description = styled.div`
    grid-column: span 2;
`

const CreationCaptureInfoMetadataDescriptionField = () => {
    return (
        <Description>
            Information entered here will apply to all media within this capture. Information entered on individual
            media will override these fields, and is highly recommended. You will be able to edit this again at upload.
        </Description>
    )
}

export default CreationCaptureInfoMetadataDescriptionField
